import React from "react";

const ContentContainer = ({ children }) => {
  return <div className="flex-1">{children}</div>;
};

export default ContentContainer;
